import {clearResource, setResource} from 'redux/actions'
import reduxStore from 'redux/store'
import {RestRequestBLOB, RestRequestGET} from "../libs/RestRequest";
import Endpoints from "../constants/Endpoints";
import applySearchParams from "../libs/applySearchParams";

const EMAIL_LIST_RESOURCE_ID = 'emailList';
const EMAIL_LIST_ACTIONS_RESOURCE_ID = 'emailListActions';



const getEmailList = async (id, pagination, searchData = {}) => {
    try {
        let params = {
            ...pagination
        }

        params = applySearchParams(searchData, params);

        const res = await RestRequestGET(Endpoints.EMAIL_LIST(id), {params});

        reduxStore.dispatch(
            setResource(EMAIL_LIST_RESOURCE_ID, res)
        )
    } catch (error) {
    }
}


const getEmailListActions = async (id) => {
    try {
        const res = await RestRequestGET(Endpoints.EMAIL_LIST_ACTIONS(id));
        reduxStore.dispatch(
            setResource(EMAIL_LIST_ACTIONS_RESOURCE_ID, res.actions)
        )
    } catch (error) {
    }
}

const getEmailDetails = async (demandId, emailId) => {
    return await RestRequestGET(Endpoints.EMAIL_DETAILS(demandId, emailId));
}


const doExportEmails = (url, finallyCallback = () => {
}) => {
    try {
        RestRequestBLOB(url)
            .finally(finallyCallback);
    } catch (error) {
    }
}

const printEmailDetails = (demandId, emailId, finallyCallback = () => {}) => {
    try {
        RestRequestBLOB(Endpoints.EMAIL_PRINT(demandId, emailId)).finally(finallyCallback);
    } catch (error) {
    }
}

const clearResources = (resource) => reduxStore.dispatch(clearResource(resource));

export default {
    getEmailList,
    getEmailListActions,
    getEmailDetails,
    clearResources,
    doExportEmails,
    printEmailDetails,
    EMAIL_LIST_RESOURCE_ID,
    EMAIL_LIST_ACTIONS_RESOURCE_ID
}